export default "__VITE_ASSET__770c8c78__"